import React, { useState, useEffect } from 'react';

const links = [
  { label: 'Why RS', href: '#why' },
  { label: 'Courses', href: '#courses' },
  { label: 'About', href: '#about' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'Contact', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [menuOpen, setMenuOpen] = useState(false);

  // scroll effect
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  // responsive detection
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <nav
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 100,
        background: scrolled ? 'rgba(8,11,20,0.92)' : 'transparent',
        borderBottom: scrolled
          ? '1px solid rgba(99,179,237,0.10)'
          : '1px solid transparent',
        backdropFilter: scrolled ? 'blur(16px)' : 'none',
        transition: 'all 0.3s ease',
      }}
    >
      <div
        style={{
          maxWidth: '1120px',
          margin: '0 auto',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: isMobile ? '0.8rem 1rem' : '1rem 2rem',
        }}
      >
        {/* Logo */}
        <div
          style={{
            fontSize: isMobile ? '18px' : '22px',
            fontWeight: '800',
            color: '#f0f4ff',
          }}
        >
          RS<span style={{ color: '#0ff4c6' }}>Courses</span>
        </div>

        {/* Desktop Links */}
        {!isMobile && (
          <ul
            style={{
              display: 'flex',
              gap: '2rem',
              listStyle: 'none',
            }}
          >
            {links.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  style={{
                    fontSize: '14px',
                    color: '#94a3c4',
                    transition: 'color 0.2s',
                  }}
                  onMouseEnter={(e) =>
                    (e.target.style.color = '#0ff4c6')
                  }
                  onMouseLeave={(e) =>
                    (e.target.style.color = '#94a3c4')
                  }
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        )}

        {/* Desktop Button */}
        {!isMobile && (
          <button
            style={{
              background: 'transparent',
              color: '#0ff4c6',
              border: '1.5px solid #0ff4c6',
              padding: '8px 18px',
              borderRadius: '999px',
              fontSize: '13px',
              cursor: 'pointer',
            }}
          >
            Free Demo ↗
          </button>
        )}

        {/* Mobile Menu Button */}
        {isMobile && (
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            style={{
              fontSize: '22px',
              color: '#fff',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
            }}
          >
            ☰
          </button>
        )}
      </div>

      {/* Mobile Menu */}
      {isMobile && menuOpen && (
        <div
          style={{
            background: '#080b14',
            padding: '1rem',
            borderTop: '1px solid rgba(99,179,237,0.1)',
          }}
        >
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              style={{
                display: 'block',
                padding: '10px 0',
                color: '#94a3c4',
                fontSize: '14px',
              }}
              onClick={() => setMenuOpen(false)}
            >
              {l.label}
            </a>
          ))}

          <button
            style={{
              marginTop: '10px',
              width: '100%',
              padding: '10px',
              borderRadius: '999px',
              background: '#0ff4c6',
              border: 'none',
              fontWeight: '600',
            }}
          >
            Free Demo ↗
          </button>
        </div>
      )}
    </nav>
  );
}